import { useSettings } from "../lib/SettingsContext";

const GREETING = "Hi Cake Central, I'd love to enquire about a cake!";

/**
 * Floating WhatsApp contact button (bottom-right). Opens a WhatsApp chat to the
 * business number from admin Settings, pre-filled with a friendly greeting.
 * Works on mobile (opens the app) and desktop (opens WhatsApp Web).
 */
export default function WhatsAppButton() {
    const { settings } = useSettings();

    // Normalise the AU number to international format for wa.me:
    // strip non-digits, then turn a leading 0 into 61 (Australia).
    const raw = (settings?.whatsapp || settings?.phone || "").replace(/[^\d]/g, "");
    const intl = raw.startsWith("0") ? "61" + raw.slice(1) : raw;
    if (!intl) return null;

    const href = `https://wa.me/${intl}?text=${encodeURIComponent(GREETING)}`;

    return (
        <a
            href={href}
            target="_blank"
            rel="noreferrer"
            aria-label="Chat with us on WhatsApp"
            data-testid="whatsapp-button"
            className="fixed bottom-6 right-6 z-50 flex items-center justify-center w-14 h-14 rounded-full shadow-lg transition-transform hover:scale-105"
            style={{ backgroundColor: "#25D366" }}
        >
            <svg viewBox="0 0 32 32" width="30" height="30" fill="#fff" aria-hidden="true">
                <path d="M16.004 3.2c-7.06 0-12.8 5.74-12.8 12.8 0 2.257.59 4.46 1.71 6.4L3.2 28.8l6.56-1.72a12.74 12.74 0 0 0 6.244 1.62h.005c7.06 0 12.8-5.74 12.8-12.8s-5.74-12.8-12.8-12.8zm0 23.36h-.004a10.56 10.56 0 0 1-5.38-1.474l-.386-.23-3.893 1.02 1.04-3.795-.252-.39a10.55 10.55 0 0 1-1.617-5.63c0-5.83 4.744-10.573 10.578-10.573 2.824 0 5.478 1.1 7.474 3.098a10.5 10.5 0 0 1 3.096 7.48c0 5.833-4.744 10.577-10.573 10.577zm5.8-7.918c-.318-.16-1.88-.928-2.172-1.034-.29-.106-.502-.16-.714.16-.212.317-.82 1.033-1.005 1.245-.185.212-.37.238-.688.08-.318-.16-1.343-.495-2.558-1.578-.945-.843-1.583-1.884-1.768-2.202-.185-.317-.02-.49.14-.647.144-.143.318-.37.477-.556.16-.185.212-.317.318-.53.106-.212.053-.397-.027-.556-.08-.16-.714-1.723-.98-2.36-.257-.618-.52-.534-.714-.544l-.61-.01c-.212 0-.556.08-.847.397-.29.318-1.112 1.087-1.112 2.65 0 1.564 1.138 3.074 1.297 3.286.16.212 2.24 3.42 5.426 4.795.758.328 1.35.524 1.81.67.76.242 1.453.208 2.001.126.61-.09 1.88-.768 2.145-1.51.265-.74.265-1.376.185-1.51-.079-.132-.29-.212-.608-.372z" />
            </svg>
        </a>
    );
}
